import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

//import { SignUpLink } from '../SignUp';
//import { PasswordForgetLink } from '../PasswordForget';
import { withFirebase } from '../../components/Firebase';
import withAuthorization from '../../components/Session/withAuthorization'
import * as ROUTES from '../../constants/routes';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Checkbox from '@material-ui/core/Checkbox';
//import Link from '@material-ui/core/Link';
//import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const condition = authUser => authUser==null;

const PasswordForgetPage = (props) => {
  const classes = useStyles();
  //const [textSignIn,setTextSignIn]=React.useState("Reset");
  return (
    <Container component="main" maxWidth="xs">
    <CssBaseline />
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Forget Password
      </Typography>
      <PasswordForgetForm classes={classes}/>
    </div>
    <Box mt={5}>
      
    </Box>
  </Container>
  
)};
export default withAuthorization(condition,ROUTES.HOME)(PasswordForgetPage);

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  alert: {
    color: 'red',
  },
}));

const INITIAL_STATE = {
  email: '',
  error: null,
  textSignIn: "Reset"
};

class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email } = this.state;
    this.setState({textSignIn:"Loading...",error:null})

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        //this.setState({textSignIn:"Success",error:null})
        alert("Reset Link has been sent to your email.Please check your email")
        this.props.history.push(ROUTES.SIGN_IN)
      })
      .catch(error => {
        this.setState({textSignIn:"Reset"})
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, error , textSignIn} = this.state;

    const isInvalid = email === '';

    return (
      //<form onSubmit={this.onSubmit}>
      //  <input
      //    name="email"
      //    value={this.state.email}
      //    onChange={this.onChange}
      //    type="text"
      //    placeholder="Email Address"
       // />
      //  <button disabled={isInvalid} type="submit">
      //    Reset My Password
      //  </button>

      //  {error && <p>{error.message}</p>}

      //</form>

      <form noValidate className={this.props.classes.form} onSubmit={this.onSubmit} >
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={this.onChange}
        />
        
        {/*}
        <FormControlLabel
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        />
        */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={this.props.classes.submit}
          disabled={isInvalid}
        >
          {textSignIn}
        </Button>
        {error && <p className={this.props.classes.alert}>{error.message}</p>}
        
        </form>
    );
  }
}

const PasswordForgetLink = (props) => (
  <p>
    <Link to={ROUTES.PASSWORD_FORGET}>Forgot Password?</Link>
  </p>
);

//export default PasswordForgetPage;
const PasswordForgetForm = compose(
  withRouter,
  withFirebase,
)(PasswordForgetFormBase);

//const PasswordForgetForm = withFirebase(PasswordForgetFormBase);

export { PasswordForgetForm, PasswordForgetLink };